type AgencyClientScope = {
  id: string;
  userId: string | null;
};

type CapiClientScopeInput = {
  isAgencyUser: boolean;
  selectedClientId: string | null;
  selectedClient: AgencyClientScope | null;
  isLoading: boolean;
};

export type CapiClientScope =
  | { state: "ready"; forUserId: string | null }
  | { state: "loading" | "unavailable"; forUserId: null };

export function resolveCapiClientScope({
  isAgencyUser,
  selectedClientId,
  selectedClient,
  isLoading,
}: CapiClientScopeInput): CapiClientScope {
  if (!isAgencyUser || !selectedClientId) {
    return { state: "ready", forUserId: null };
  }

  if (isLoading) {
    return { state: "loading", forUserId: null };
  }

  if (selectedClient?.id !== selectedClientId || !selectedClient.userId) {
    return { state: "unavailable", forUserId: null };
  }

  return { state: "ready", forUserId: selectedClient.userId };
}
